import template from './notification_management.all.html';
import controller from './notification_management.all.controller';
import './notification_management.all.scss';

let NotificationManagementAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default NotificationManagementAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/all/notification_management.all.component.js